import { generateUUID } from '@shared/utils/uuid';
import { FlightProduct, SeatingProduct } from '@/api/Cart/cart.interfaces';
import { Market } from '@shared/config/market/market.models';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';
const market: Market = getCurrentMarketSpecs();
const Currency = market.moneyFormat.currency;

export function getFakeSeating(product: FlightProduct) {
    const selectedSeats: SeatingProduct[] = [
        {
            Id: 'Seat: 1A, NK 1722',
            Description: 'Seat: 1A, NK 1722',
            Price: {
                Amount: 150,
                Currency,
            },
            Row: 1,
            Column: 'A',
            PriceBreakdown: {
                SupplierPrice: {
                    Amount: 100,
                    Currency,
                },
                TotalPrice: {
                    Amount: 150,
                    Currency,
                },
                BookingFee: {
                    Amount: 50,
                    Currency,
                },
            },
        },
        {
            Id: 'Seat: 10B, NK 1700',
            Description: 'Seat: 10B, NK 1700',
            Price: {
                Amount: 75,
                Currency,
            },
            Row: 10,
            Column: 'B',
            PriceBreakdown: {
                SupplierPrice: {
                    Amount: 60,
                    Currency,
                },
                TotalPrice: {
                    Amount: 75,
                    Currency,
                },
                BookingFee: {
                    Amount: 15,
                    Currency,
                },
            },
        },
    ];
    return {
        ...product,
        Pax: product.Pax.map((pax) => ({
            ...pax,
            FirstName: null,
            LastName: null,
            SelectedSeats: selectedSeats.map((seat) => ({
                ...seat,
                Id: generateUUID(),
            })),
        })),
    };
}
